import(/* webpackMode: "eager" */ "/builds/idp-education/idp-connect/he-websites/next-js/he-websites/apps/whatuni/src/app/open-days/not-found.tsx");
